const CONTENT_SECTION_TYPE = {
  base: 'base',
  gallery: 'gallery',
  slider: 'slider',
  blockBuilder: 'builder',
};

export default CONTENT_SECTION_TYPE;
